import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import Hero from '@/pages/home/components/Hero';
import HotGossip from '@/pages/home/components/HotGossip';
import Features from '@/pages/home/components/Features';
import CTA from '@/pages/home/components/CTA';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '51黑料吃瓜网',
  alternateName: '51爆料网',
  url: 'https://51heiliaochigua.com',
  description: '51黑料吃瓜网汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源，深度起底热门事件真相。51爆料网24小时不打烊实时推送最新大瓜，吃瓜群众速来围观，免费查看全网最热黑料合集！',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://51heiliaochigua.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '51黑料吃瓜网',
  alternateName: '51爆料网',
  url: 'https://51heiliaochigua.com',
  description: '汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源的娱乐资讯平台',
  email: 'contact@51heiliaochigua.com',
  telephone: '400-888-8888',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressRegion: '北京市',
    addressCountry: 'CN',
    streetAddress: '朝阳区星光大道88号传媒大厦15层',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '51黑料吃瓜网的信息来源可靠吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '51黑料吃瓜网采用多渠道交叉验证机制，所有爆料信息均经过专业团队核实后发布。我们与多家娱乐媒体、行业内人士保持紧密合作，确保每一条爆料的真实性和可靠性。',
      },
    },
    {
      '@type': 'Question',
      name: '如何第一时间获取最新爆料？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以关注51黑料吃瓜网的社交媒体账号（微博、抖音、小红书），或订阅我们的邮件推送服务。我们24小时不打烊，实时监控全网热点，确保您永远走在吃瓜第一线。',
      },
    },
    {
      '@type': 'Question',
      name: '51爆料网是否可以投稿爆料？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '当然可以！我们欢迎所有吃瓜群众投稿爆料。您可以通过网站底部的联系方式发送邮件，或私信我们的社交媒体账号。所有投稿均严格保密，保护爆料人隐私。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <PageMeta
        title="51黑料吃瓜网 | 51爆料网 - 网红明星黑料大全 | 娱乐圈八卦 | 吃瓜群众聚集地每日不打烊"
        description="51黑料吃瓜网汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源，深度起底热门事件真相。51爆料网24小时不打烊实时推送最新大瓜，吃瓜群众速来围观，免费查看全网最热黑料合集！"
        keywords="51黑料吃瓜网,51爆料网,明星黑料,娱乐圈八卦,吃瓜群众,网红大瓜,黑料不打烊,实时爆料,吃瓜爆料,51黑料"
        canonical="https://51heiliaochigua.com"
        ogTitle="51黑料吃瓜网 | 51爆料网 - 网红明星黑料大全 | 娱乐圈八卦 | 吃瓜群众聚集地"
        ogDescription="51黑料吃瓜网汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源，深度起底热门事件真相。24小时不打烊实时推送最新大瓜！"
        ogUrl="https://51heiliaochigua.com"
        twitterTitle="51黑料吃瓜网 | 51爆料网 - 网红明星黑料大全"
        twitterDescription="51黑料吃瓜网汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源，深度起底热门事件真相。"
        jsonLdScripts={[homepageJsonLd, organizationJsonLd, faqJsonLd]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <Hero />
            <HotGossip />
            <Features />
            <CTA />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}